import React from "react";
import "./Footer.css"; 
import fb from "../../assets/fb.png";
import tweet from "../../assets/tweet.png";
import insta from "../../assets/insta.png";
import HruthAi from '../../assets/Hruthi AI SVG Logo.svg'
import { useNavigate } from 'react-router-dom';
import { FaPhoneVolume } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Left Section */}
        <div className="footer-section about">
        <img src={HruthAi} alt="" className="footer-hruthi-logo"/>
          {/* <h2>HruthiAI</h2> */}
          <p className="footer-hruthi-p">
            Job Market's Most Demanding Skills, Experience, and Lucrative Career
            Transformation. 100% Job Guaranteed Courses in Cyber Security, Data
            Analytics & Fullstack Development for Fresh Graduates in 2021, 2022,
            2023 & 2024, and Gap Year Experience Consultants with No-Code
            Knowledge.
          </p>
          {/* <p>Chamber of commerce: 9190116213</p> */}
          <div className="social-icons">
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <img src={fb} alt="Facebook" />
            </a>
            {/* <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
              <img src={tweet} alt="Twitter" />
            </a> */}
            <a href="https://www.instagram.com/hruthiaitechhub?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">
              <img src={insta} alt="Instagram" />
            </a>
          </div>
        </div>

        {/* Links Section */}
        <div className="footer-section links">
          
          <h3>HruthiAI</h3>
          <ul>
            <li onClick={()=>navigate('/about')}>About Us</li>
            {/* <li>Franchise Partner</li> */}
            {/* <li>Sportshoes</li> */}
            <li>Placements</li>
            {/* <li>Apply Now</li> */}
            <li onClick={()=>navigate('/terms')}>Terms & Conditions</li>
            <li onClick={()=>navigate('/contact')}>Contact Us</li>
            {/* <li>Knowledge Hub</li> */}
          </ul>
        </div>

        <div className="footer-section services">
          <h3>Services</h3>
          <ul>
            <li>Cyber Security</li>
            <li>Data Science</li>
            <li>Data Analytics</li>
            <li>Full Stack Development</li>
            <li>Cloud Services</li>
            {/* <li>Linux+</li> */}
            {/* <li>Server+</li> */}
          </ul>
        </div>

        <div className="footer-section subscribe">
          <h3>Subscribe Now</h3>
          <p>Don't miss our future updates! Get Subscribed Today!</p>
          <div className="subscribe-form">
            <input type="email" placeholder="your mail here" />
            <button>Submit</button>
          </div>
          <p style={{fontSize: "20px"}}><FaPhoneVolume /> 89775 17381</p>
          <p style={{fontSize: "20px"}}><IoMdMail /> info@hruthiaitechhub.com</p>
        </div>
      </div>

      {/* Programs Section */}
      <div className="footer-programs">
        <div className="programs-column">
          <h3>Programs For Freshers</h3>
          <ul>
            <li>Cyber Security Analyst - SOC </li>
            <li>Web Application Pentester & Ethical Hacking</li>
            <li>Data Analytics with AI</li>
            <li>Data Science - AI & ML with Internship</li>
            <li>Full Stack (MERN) with AI Internship</li>
            <li>AI Automation Power Apps Developer</li>
          </ul>
        </div>
        <div className="programs-column1">
          <h3>Programs For Working Professionals</h3>
          <ul>
            <li>Cyber Security Engineer Expert</li>
            <li>Data Analytics With AI Specialization</li>
            <li>Data Scientist - AI & ML</li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
